import httpRequest from "services/httpRequest";

const _prefix = "/api/broadcast";

export const onCreateBroadcast = async params => {
  const result = await httpRequest({
    url: `${_prefix}`,
    method: "POST",
    data: params,
    successMessage: "toast.send_success",
  });
  return result;
};
export const onGetAddressPage = async params => {
  const result = await httpRequest({
    url: "/api/service",
    method: "GET",
    params: params,
  });
  return result;
};

export const onGetAddressToBroadcastMessage = async params => {
  const result = await httpRequest({
    url: "/api/service/broad-cast",
    method: "GET",
    params: params,
  });
  return result;
};
